export default {
    create_dealer_create_title: 'Create Dealer',
    create_dealer_edit_title: 'Edit Dealer',
    create_dealer_the_dealer_was_created: 'The dealer was created',
    create_dealer_dealer_name: 'Dealer Name',
    create_dealer_dealer_name_min_error: 'The dealer name must contain minimum chars',
    create_dealer_dealer_name_max_error: 'The dealer name contain maximum chars',
    create_dealer_language: 'Language',
    create_dealer_time_zone: 'Time Zone',
    create_dealer_brand: 'Brand',
    create_dealer_crm: 'Salesforce Id',
    create_dealer_crm_min_error: 'The Salesforce Id must contain minimum chars',
    create_dealer_internal: 'Internal',
    create_dealer_yes: 'Yes',
    create_dealer_not: 'No',
    create_dealer_username: 'Username',
    create_dealer_username_error_min: 'The username must contain minimum chars',
    create_dealer_username_error_max: 'The username must contain maximum chars',
    create_dealer_email: 'Email',
    create_dealer_password: 'Password',
    create_dealer_role: 'Role',
    create_dealer_report_options: 'Report Options',
    create_dealer_site_options: 'Site Options',
    create_dealer_no_options: 'No Options',
    create_dealer_the_dealer_has_been_edited: 'The dealer has been edited',
    create_dealer_general: 'General',
    create_dealer_packages: 'Packages',
    create_dealer_automatic: 'Automatic',
    create_dealer_manual: 'Manually',
    create_dealer_click_to_copy_password: 'Click to copy password!',
    create_dealer_the_password_was_copied: 'The password was copied',
    create_dealer_package: 'Package',
    create_dealer_select: 'Select...',
    create_dealer_crm_max_error: 'The Salesforce Id must contain a maximum of chars',
    create_dealer_promiles_username: 'Promiles Username',
    create_dealer_promiles_email: 'Promiles Email',
    create_dealer_fuel_card_company_code: 'Fuel Card Company Code',
    create_dealer_additional_info: 'Additional Information',
    create_dealer_error_username: 'The username must contain only lowercase letters and numbers, spaces are not valid',
    create_dealer_verify_terms_conditions: 'Verify Terms and Conditions',
    create_dealer_verify_terms_conditions_message: "By activating this option (YES) requires the users the acceptance of terms and conditions during the authentication process. Once accepted the T&C the system doesn't prompt for this again",
    create_dealer_speed_limit_engine: 'Speed Limit Engine',
    create_dealer_rgeo_engine: 'Rgeo Engine',
    create_dealer_osm_with_fallback_google: "OSM with fallback to Google",
    create_dealer_osm_only: "OSM Only",
    create_dealer_web_service_integration: "WEX EFS",
    create_dealer_status: "Status",
    create_dealer_validate_credentials: "Validate Credentials",
    create_dealer_active: "Active",
    create_dealer_inactive: "Inactive",
    create_dealer_fuel_card_integrations: "Fuel Card Integrations",
    create_dealer_wex_credencials_success: "Credentials are valid",
    create_dealer_wex_credencials_error: "Credentials are invalid",
    create_dealer_wex_credencials_message: "Credentials must be validated",
    create_dealer_promiles: "Promiles",
    create_dealer_fuel_cards: "Fuel Cards",
    create_dealer_web_services_status: "Web Services Status",
    create_dealer_master_company: "Master Company",
    create_delaer_brand: "Brand",
};